module.exports = __webpack_public_path__ + "img/launch-mobile.d32e6d9f.png";